/* eslint-disable no-underscore-dangle */
import { DEFAULTS, DEVICE_PLATFORM_MAP } from '../../../const';

function _normalizeDeployments(deployments, clientId) {
  const credentials = {};
  if (deployments) {
    deployments.forEach(deployment => {
      if (deployment.client_id === clientId) {
        credentials[deployment.platform_id.toString()] = {
          id: deployment.id,
          businessId: deployment.business_id,
          platformId: deployment.platform_id,
          clientId: deployment.client_id,
          active: deployment.active,
          edited: deployment.edited,
          callbackURL: deployment.callback_url,
          ...deployment.credentials,
        };
      }
    });
  }

  return credentials;
}

function _normalizePartnerSettings(clientId, partnerData, deployments) {
  const { tasks, config: sdkConfiguration } = partnerData;
  return {
    sdkConfiguration:
      sdkConfiguration && sdkConfiguration[DEVICE_PLATFORM_MAP.WEBSDK]
        ? {
            ...Object.assign(
              {},
              DEFAULTS.SDK_CONFIG,
              sdkConfiguration[DEVICE_PLATFORM_MAP.WEBSDK]
            ),
            businessActive: partnerData.active,
            showHaptikBranding: !partnerData.hide_branding,
            businessIcon: partnerData.image_url,
            webhookEnabled: partnerData.webhook_enabled,
          }
        : DEFAULTS.SDK_CONFIG,
    botBreakMessage: partnerData.botbreak_template,
    outlierMessage: partnerData.outlier_template,
    taskboxSettings: { tasks },
    platformDeployments: _normalizeDeployments(deployments, clientId),
  };
}

function _getPartnerDataIndexedByName(data, map, allClients, deployments) {
  const newIndex = {};
  const partnerData = data.partner_data;
  Object.keys(partnerData).forEach(key => {
    const client = allClients.filter(c => c.name === map[key])[0];
    newIndex[map[key]] = _normalizePartnerSettings(
      client.client_id,
      partnerData[key],
      deployments
    );
  });
  return newIndex;
}

const normalizeToPartnerSpecificSettings = data => {
  const { businessResponse, deploymentResponse } = data;
  const { meta, body: businesses } = businessResponse;
  const business = businesses[0];
  return {
    activeBots: business.active_list.map(id => meta.partner_id_map[id]),
    allTasks: business.tasks.map(task => ({
      ...task,
    })),
    taskboxMessage: business.task_box_header,
    callbackBaseUrl: deploymentResponse.meta.callback_base_url,
    settingsIndexed: _getPartnerDataIndexedByName(
      business,
      meta.partner_id_map,
      deploymentResponse.meta.client_list,
      deploymentResponse.body
    ),
  };
};

export default normalizeToPartnerSpecificSettings;
